import { enqueueError } from '@paragon/notification-tools';
import { addSpinnerMessage, removeSpinnerMessage } from '@paragon/task-spinner';

import { getProductionComponentInstancesByProductionGroupGuid } from '../selectors/getProductionComponentInstancesByProductionGroupGuid';
import { getProductionGroupsByProjectGuid } from '../selectors/productionGroups';
import { loadComponentsForProductionComponentInstances } from './componentActions';
import { loadProductionGroupsData } from './loadProductionGroupsData';
import { loadProductionGroupsForProject } from './loadProductionGroupsForProject';
import { AsyncThunkActionVoid } from './thunkActions';
import { loadTruckloadsForProject } from './truckloadActions';

export function loadAllDataForProject(projectGuid: string, spinner = true): AsyncThunkActionVoid {
  return async function loadAllDataForProjectThunkAction(dispatch, getState) {
    const spinnerId = spinner ? dispatch(addSpinnerMessage('Loading data for project...')) : null;
    try {
      await dispatch(loadProductionGroupsForProject(projectGuid, false));
      const productionGroupsByProjectGuid = getProductionGroupsByProjectGuid(getState());
      const productionGroupsForProject = productionGroupsByProjectGuid[projectGuid];
      await dispatch(loadProductionGroupsData(productionGroupsForProject.map(({ guid }) => guid)));

      dispatch(loadTruckloadsForProject(projectGuid, false));

      const productionComponentInstancesByProductionGroupGuid =
        getProductionComponentInstancesByProductionGroupGuid(getState());
      const productionComponentInstances = productionGroupsForProject.flatMap(
        ({ guid }) => productionComponentInstancesByProductionGroupGuid[guid],
      );
      await dispatch(loadComponentsForProductionComponentInstances(productionComponentInstances));
    } catch (error) {
      console.error(error);
      dispatch(enqueueError('Error loading data for project'));
    } finally {
      if (spinnerId) dispatch(removeSpinnerMessage(spinnerId));
    }
  };
}
